export const SURVEYS_KEY = "surveys";
export const SURVEY_INTERVAL_DAYS = 1;
